import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import HeroSection from "../../layout/HeroSection";
import Loader from "../../components/other/Loader";
import { pageRoutes } from "../../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import NoRecord from "../../components/other/NoRecord";
import { fetchEmbeds } from "../../redux/action/embedActions";
const Lexicon = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const { isLoading, embedList } = useSelector((state) => state.embedReducer);

  const menuItems = {
    lexicon: [
      {
        label: "Antweights",
        route: pageRoutes.weightClassSpecificInfo?.plasticAntweights,
      },
      {
        label: "Batteries",
        route: pageRoutes.lessons?.electricalEngineeringMenu?.batteries,
      },
      { label: "Battlebots", route: pageRoutes.battleBots },
      {
        label: "Beetleweights",
        route: pageRoutes.weightClassSpecificInfo?.beetleweights,
      },
      {
        label: "BESC",
        route: pageRoutes.lessons?.electricalEngineeringMenu?.escs_bescs,
      },
      { label: "Control Bots", route: pageRoutes?.controlBots },
      { label: "Drum Spinners", route: pageRoutes?.drumSpinners },
      {
        label: "ESC",
        route: pageRoutes.lessons?.electricalEngineeringMenu?.escs_bescs,
      },
      {
        label: "Fairyweights",
        route: pageRoutes.weightClassSpecificInfo?.fairyweights,
      },
      {
        label: "Featherweights (30lb.)",
        route: pageRoutes?.weightClassSpecificInfo?.featherweights,
      },
      { label: "Firebots", route: pageRoutes?.firebots },
      { label: "Flipper bots", route: pageRoutes?.fliperBots },
      {
        label: "Fusion 360",
        route: pageRoutes.lessons?.threeDModlingMenu?.fusion,
      },
      { label: "Gearboxes", route: pageRoutes?.gearboxes },
      { label: "Hammerbots", route: pageRoutes?.hammerbots },
      { label: "Hand Tools", route: pageRoutes?.handTools },
      {
        label: "Hobbyweights",
        route: pageRoutes.weightClassSpecificInfo?.hobbyweights,
      },
      { label: "Horizontal spinners", route: pageRoutes?.horizontalSpinners },
      { label: "Materials", route: pageRoutes.lessons?.materialScience },
      {
        label: "Modes of transferring motion",
        route: pageRoutes?.modesOfTransferringMotion,
      },
      { label: "Motors", route: pageRoutes.lessons?.brushedVsBrushlessMotors },
      { label: "NHRL", route: pageRoutes?.nhrl },
      { label: "Overhead Saws", route: pageRoutes?.overheadSaws },
      { label: "Plants", route: pageRoutes?.plants },
      {
        label: "Plastic Antweights",
        route: pageRoutes?.weightClassSpecificInfo?.plasticAntweights,
      },
      { label: "Power Tools", route: pageRoutes?.powerTools },
      {
        label: "Printed Circuit Board (Malenki)",
        route: pageRoutes?.printedCircuitBoards,
      },
      { label: "RCL", route: pageRoutes?.rcl },
      {
        label: "Receiver",
        route: pageRoutes.lessons?.electricalEngineeringMenu?.receivers,
      },
      { label: "Soldering Tools", route: pageRoutes.lessons?.soldering },
      {
        label: "Sportsmans (30lb.)",
        route: pageRoutes?.weightClassSpecificInfo?.sportsmans,
      },
      { label: "SSP", route: pageRoutes?.ssp },
      {
        label: "Tinkercad",
        route: pageRoutes.lessons?.threeDModlingMenu?.tinkercad,
      },
      { label: "Turnabot", route: pageRoutes?.turnabots },
      {
        label: "Types of drive systems",
        route: pageRoutes?.typesOfDriveSystem,
      },
      { label: "Vertical spinners", route: pageRoutes?.verticalSpinners },
    ],
    category: [
      {
        label: "Weight classes/restrictions",
        route:
          pageRoutes?.getStarted?.thingsToKnowBefore?.weightClassesRestrictions,
      },
      // {
      //   label: "Good kits to start with",
      //   route: pageRoutes?.getStarted?.goodKidsToStart,
      // },
      // { label: "Things to know before you begin" },
      { label: "Drive Systems", route: pageRoutes?.driveSystems },
      { label: "Weapons systems", route: pageRoutes?.weaponsSystems },
      {
        label: "Electrical",
        route: pageRoutes?.lessons?.electricalEngineering,
      },
      { label: "3D Modeling", route: pageRoutes.lessons?.threeDModling },
      // { label: "Fabrication" },
      // { label: "Weight Class-Specific Info. and tips" },
      { label: "Tools of the Trade", route: pageRoutes.more?.toolsOfTheTrade },
    ],
  };

  const filteredLexicon = embedList?.lexicon?.filter((item) =>
    searchTerm ? item?.title?.toLowerCase()?.includes(searchTerm) : item
  );

  const filteredWeightClasses = embedList?.weight_classes?.filter((item) =>
    searchTerm ? item?.title?.toLowerCase()?.includes(searchTerm) : item
  );

  const filteredToolsOfTheTrade = embedList?.tools_of_trades?.filter((item) =>
   searchTerm ?  item?.title?.toLowerCase()?.includes(searchTerm) : item
  );
  useEffect(() => {
    dispatch(fetchEmbeds());
  }, []);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div>
      <Header />
      <HeroSection
        label={<h1 class="mb-3">{"Knowledgebase"}</h1>}
        // breadcrumbItems={[
        //   { name: "Home", path: `${pageRoutes?.home}` },
        //   {
        //     name: "Knowledgebase",
        //     path: `${pageRoutes?.home}`,
        //   },
        // ]}
        // banner_image={aboutData?.about_banner}
      />

      <section className="untree_co-section pt-5 pb-5 ">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              {/* <h2 class="section-title mb-5 text-center">
                <strong>Knowledgebase</strong>
              </h2> */}

              <div className="ct_search_keyword_input_main">
                <p className="mb-0 ct_ff_orbitron">Search by keyword:</p>
                <input
                  type="text"
                  className="form-control"
                  value={searchTerm}
                  onChange={handleSearch}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8 mx-auto">
              <div className="row">
                <div className="col-sm-4 mb-4 mb-sm-0">
                  <div className="ct_lexicon_links">
                    <h4 className="text-dark ct_ff_orbitron">Lexicon</h4>
                    <p className="mb-0">(Browse by Title)</p>
                    <ul>
                      {filteredLexicon?.length > 0 ? (
                        filteredLexicon?.map((item, index) => (
                          <li key={index}>
                            <a
                              href="javascript:void(0)"
                              onClick={() =>
                                navigate(pageRoutes.testing, {
                                  state: { data: item },
                                })
                              }
                            >
                              {item.title}
                            </a>
                          </li>
                        ))
                      ) : (
                        <NoRecord className={"text-start"} />
                      )}
                    </ul>
                  </div>
                </div>
                <div className="col-sm-4 mb-4 mb-sm-0">
                  <div className="ct_lexicon_links">
                    <h4 className="text-dark ct_ff_orbitron">Weight Classes</h4>
                    <p className="mb-0">(Browse by Title)</p>
                    <ul>
                      {filteredWeightClasses?.length > 0 ? (
                        filteredWeightClasses?.map((item, index) => (
                          <li key={index}>
                            <a
                              href="javascript:void(0)"
                              onClick={() =>
                                navigate(pageRoutes.testing, {
                                  state: { data: item },
                                })
                              }
                            >
                              {item.title}
                            </a>
                          </li>
                        ))
                      ) : (
                        <NoRecord className={"text-start"} />
                      )}
                    </ul>
                  </div>
                </div>
                <div className="col-sm-4 mb-4 mb-sm-0">
                  <div className="ct_lexicon_links">
                    <h4 className="text-dark ct_ff_orbitron">
                    Tools of the Trade
                    </h4>
                    <p className="mb-0">(Browse by Title)</p>
                    <ul>
                      {filteredToolsOfTheTrade?.length > 0 ? (
                        filteredToolsOfTheTrade?.map((item, index) => (
                          <li key={index}>
                            <a
                              href="javascript:void(0)"
                              onClick={() =>
                                navigate(pageRoutes.testing, {
                                  state: { data: item },
                                })
                              }
                            >
                              {item.title}
                            </a>
                          </li>
                        ))
                      ) : (
                        <NoRecord className={"text-start"} />
                      )}
                    </ul>
                  </div>
                </div>
                {/* <div className="col-sm-4 mb-4 mb-sm-0">
                  <div className="ct_lexicon_links">
                    <h4 className="text-dark ct_ff_orbitron">Embeds</h4>
                    <ul>
                      {embedList?.map((item, index) => (
                        <li key={index}>
                          <a
                            href="javascript:void(0)"
                            onClick={() =>
                              navigate(pageRoutes.testing, {
                                state: { data: item },
                              })
                            }
                          >
                            {item.title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Lexicon;
